<!--
* @Author: DY
* @Date: 2021年4月21日22:20:54
* @Description: '全局自定义按钮出表单'
-->
<template>
    <div class="popUpForm customBtnForm" v-loading="loading">
        <div class="content">
            <el-tabs v-model="activeName">
                <el-tab-pane name="form">
                    <span slot="label"><i class="iconfont iconbiaodan"></i>表单</span>
                    <formPage :form-data="code"></formPage>
                </el-tab-pane>
            </el-tabs>
        </div>
        <footer>
            <template v-if="isReadOnly == false">
                <el-button
                    type="primary"
                    class="save"
                    :key="btn.funName"
                    v-for="btn in btnList"
                    @click="buttonEvents(btn.funName)"
                >
                    {{ btn.name }}
                </el-button>
                <el-button
                    type="primary"
                    class="save"
                    @click="save()"
                    :loading="saveBtnLoading"
                >
                    保存
                </el-button>
            </template>
            <el-button class="Close" @click="Close">
                关闭
            </el-button>
        </footer>
    </div>
</template>

<script>
import formPage from '@/components/form/formPage';
// 全局事件
import { eventBus } from '@/common/eventBus.ts';

export default {
    name: 'custom-btn-form',
    components: {
        formPage,
    },
    props: {
        code: {
            type: [Array, Object, String],
            required: true, // 是否必传
        },
    },
    data() {
        return {
            // 加载中状态
            loading: false,
            // 默认展开tab页
            activeName: 'form',
            // 附件状态
            isDisabled: true,
            // 当前表单ID
            formId: '',
            // 表单是否只读状态,判断保存按钮是否显示
            isReadOnly: false,
            // 当前表单唯一标识
            thisFormOnly: '',
            // 按钮列表
            btnList: [],
            // 按钮点击
            statusSave: 0,
            // 保存按钮状态
            saveBtnLoading: false,
        };
    },
    watch: {},
    computed: {},
    created() {
        if (this.code.FormUrl) {
            // 表单是否只读状态,判断保存按钮是否显示
            if (this.$queryString(this.code.FormUrl, 'IsView')) {
                this.isReadOnly = true;
            } else {
                this.isReadOnly = false;
            }
            // 当前表单唯一标识赋值
            this.thisFormOnly = this.$queryString(this.code.FormUrl, 'FormCode');
        }
        if (this.code.FormKeyValue) {
            this.isDisabled = false;
            this.formId = this.code.FormKeyValue;
        }
        // 自定义按钮组
        if (this.code.btnList) {
            this.btnList = this.code.btnList;
        }
    },
    mounted() {},
    methods: {
        // 保存表单
        save() {
            this.saveBtnLoading = true;
            const iframe = window.document.getElementById('frameId' + this.thisFormOnly);
            iframe.contentWindow.JyFormSaveFormData(this.JTFlowAfterFormSaveSuccess, this.errorCallBack);
        },
        // 保存表单成功回调
        JTFlowAfterFormSaveSuccess(callbackParameter) {
            this.saveBtnLoading = false;
            if (this.code.saveCallback) {
                if (typeof this.code.saveCallback === 'function') {
                    this.code.saveCallback(callbackParameter.PKValues, eventBus, this.Close, this);
                } else {
                    window[this.code.saveCallback](callbackParameter.PKValues, eventBus, this.Close, this);
                }
            }
        },
        // 保存失败回调
        errorCallBack() {
            this.saveBtnLoading = false;
        },
        // 自定义按钮执行事件
        buttonEvents(funName) {
            const iframe = window.document.getElementById('frameId' + this.thisFormOnly);
            if (window[funName]) {
                window[funName](eventBus, this.Close, this);
            } else if (iframe.contentWindow[funName]) { // 配置表单 执行配置到表单脚本里的方法
                iframe.contentWindow[funName](this, iframe);
            } else {
                console.log(`没有配置${funName}方法。`);
            }
        },
        // 取消添加关闭弹出层
        Close() {
            this.$parent.hide();
        },
    },
};
</script>

<style lang="stylus"></style>

